const getFileExtension = (filename: string): string => {
  if (filename === '') return ''

  const chunks = filename.split('.').filter((chunk) => chunk !== '')
  if (chunks.length <= 1) return ''

  return chunks.pop()?.toLowerCase() as string
}

export default getFileExtension
